import type { PropertyValue } from '@skop-app/lib-domain/types'

export const serializeFieldMutationValue = (
  value: unknown,
  type?: PropertyValue,
): unknown => (type === 'FORMULA' ? JSON.stringify(value) : value)

export const buildFieldMutationValueInput = ({
  value,
  type,
}: {
  value: unknown
  type?: PropertyValue
}) =>
  value === undefined ? {} : { value: serializeFieldMutationValue(value, type) }
